module.exports = __webpack_public_path__ + "static/Grayic-6995525af153a14d4681be146a1bf9f0.ttf";